import { Path } from "paper";
import { addMarkers, breakPath, mirrorX, setDefaultStyle } from "../draw";
import { DEFAULT_LIQUID_DATA, markerSpacing, P, Segments } from "./common";
export class GasSyringe {
    render(appearance) {
        let length = appearance.size;
        let diameter = length / 4 + 4;
        let outletLength = 15;
        let radius = diameter / 2;
        let plungerRadius = radius - 2;
        let outletRadius = 4;
        let body = new Path(Segments(
        // Start from the tip
        [[outletRadius, length + outletLength]], [[outletRadius, length]], [[radius, length - 3], [0, 3]], // Slight rounded corner
        [[radius, 2], undefined, [0, -3]], [[radius + 4, -2]]));
        mirrorX(body);
        let liquidMask = body.clone();
        const hitShape = [body.bounds.toShape()];
        // Break the body path to show it open at the top.
        const graphic = breakPath(body, 5);
        setDefaultStyle(graphic);
        // Plunger.
        if (appearance.plunger) {
            let plunger = new Path(Segments([[plungerRadius, length - 5], [0, 3]], [[plungerRadius, -2], undefined, [30, -1]]));
            mirrorX(plunger);
            plunger.closePath();
            setDefaultStyle(plunger);
            plunger.fillColor = "#eeeeee";
            plunger.position.y -= appearance.plungerSlide * length;
            graphic.addChild(plunger);
            hitShape.push(plunger.bounds.toShape());
        }
        addMarkers(graphic, P(plungerRadius - 5, length), 0, P(0, markerSpacing));
        return {
            graphic: graphic,
            liquidMask: liquidMask,
            hitShape,
            pivot: body.bounds.center,
            snapping: {
                type: "connectable", at: P(0, length + outletLength), facing: 180,
            }
        };
    }
}
GasSyringe.properties = {
    label: "Gas Syringe",
    canContainLiquids: true,
    defaultLiquidData: Object.assign(Object.assign({}, DEFAULT_LIQUID_DATA), { amountRatio: 0.3 }),
    defaultAppearance: {
        plunger: true,
        plungerSlide: 0.4,
        size: 120,
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 80, max: 200
        },
        {
            spec: "checkbox", key: "plunger", label: "Plunger",
        },
        {
            spec: "slider", key: "plungerSlide", label: "Plunger slide",
            min: 0.0, max: 0.95, step: 0.01,
            visible: a => a.plunger
        },
    ],
};
